import { ApiTrophyResponseInterface } from '~/modules/Trophies/Application/ApiTrophyResponseInterface'
import {
  TrophyAnimation,
  TrophyAttributeDto,
  TrophyDetailComponentDto, TrophyMemoryDto
} from '~/modules/Trophies/Infrastructure/TrophyDetailComponentDto'
import { capitalize } from '~/modules/Shared/Domain/Helpers/String'
import { DateTime } from 'luxon'

export class TrophyDetailComponentTranslatorDto {
  public static fromApplication (applicationDto: ApiTrophyResponseInterface): TrophyDetailComponentDto {
    const attributes: TrophyAttributeDto[] = applicationDto.attributes.map((attribute) => (
      {
        type: attribute.trait_type,
        value: attribute.value,
      }
    ))

    const memories: TrophyMemoryDto[] = applicationDto.trophyMemories.map((memory) => (
      {
        type: memory.type,
        id: memory.id,
        trophyId: applicationDto.id,
        mediaUrl: memory.mediaUrl,
        thumbnailUrl: memory.thumbnailUrl,
        createdAt: DateTime.fromISO(memory.createdAt).toLocaleString(),
      }
    ))

    let animation: TrophyAnimation | null = null

    if (applicationDto.animation !== null) {
      animation = {
        type: applicationDto.animation.type,
        url: applicationDto.animation.value,
      }
    }

    const title =
      applicationDto.attributes.find((attribute) => attribute.trait_type === 'Full Name')?.value ?? ''

    const competition =
      applicationDto.attributes.find((attribute) => attribute.trait_type === 'Competition')?.value ?? ''

    let subtitle = ''

    const awardType =
      applicationDto.attributes.find((attribute) => attribute.trait_type === 'Award Type')

    if (awardType) {
      subtitle = awardType.value
    }

    if (applicationDto.date !== null) {
      const luxonDate = DateTime.fromISO(applicationDto.date)
      const date = capitalize(luxonDate.toLocaleString({ month: 'long' })) +
        ' ' + luxonDate.toLocaleString({ year: 'numeric' })

      subtitle = `${subtitle === '' ? '' : `${subtitle} | `}${date}`
    }

    return {
      id: applicationDto.id,
      name: applicationDto.name,
      description: applicationDto.description,
      image: applicationDto.image,
      attributes: attributes,
      mintStatus: applicationDto.mintStatus,
      animation,
      rawImageUrl: applicationDto.rawImageUrl,
      memories: memories,
      userId: applicationDto.userId,
      organizer: applicationDto.organizer,
      title,
      subtitle,
      competition,
      tokenId: applicationDto.tokenId,
      ...(applicationDto.collection && { collection: applicationDto.collection }),
    }
  }
}
